import { render } from "./EditPageContent.vue?vue&type=template&id=70753f58&scoped=true"
import script from "./EditPageContent.vue?vue&type=script&lang=js"
export * from "./EditPageContent.vue?vue&type=script&lang=js"

import "./EditPageContent.vue?vue&type=style&index=0&id=70753f58&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70753f58"]])

export default __exports__